import { createRoot } from 'react-dom/client';
import ShopTheLook from './ShopTheLook';

const sectionContainer = document.querySelector('.shop-the-look-section');
if (sectionContainer) {
  const root = createRoot(sectionContainer);
  root.render(<ShopTheLook />);
}
